module.exports = __webpack_public_path__ + "static/bluevelourfox-5296dfd829fc59d65465b2ac3d299777.jpeg";